export enum TfaCodeProvider {
  Application = 'Application',
  Email = 'Email',
  Sms = 'SMS',
}
